import StickyHeader from "./StickyHeader";
const stickyNavSelector = ".js-sticky-nav";
const stickyNavs = document.querySelectorAll(stickyNavSelector);
/**
 * Observer callback for handle affixed element state.
 */
const stickyObserverFn = (mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
            if (!StickyHeader.utils.isHeaderAffixed())
                return;
            stickyNavs.forEach((nav) => {
                // 10px as a safe top gap value from sticky header to sticky navigation
                nav.style.top = `${StickyHeader.utils.getStickyHeaderHeight() + 10}px`;
            });
        }
    });
};
/**
 * Set top value to sticky navigation dynamically if sticky header is in affixed state.
 */
function setOffsetToStickyNav() {
    if (!StickyHeader.data.stickyHeader || !stickyNavs.length)
        return;
    const stickyObserver = new MutationObserver(stickyObserverFn);
    const mutationOptions = {
        attributes: true,
        attributeFilter: ["class"],
    };
    stickyObserver.observe(StickyHeader.data.stickyHeader, mutationOptions);
}
/**
 * Sticky Navigation.
 */
export default {
    init: () => {
        setOffsetToStickyNav();
    },
};
